import { useState } from 'react';
import { MdOutlineLibraryBooks } from 'react-icons/md';
import Tooltip from '../Tooltip/Tooltip';
import './CampoHash.css';


export default function CampoHash({ value, qtdEcript = 0.0 }) {
    const [tooltip, setTooltip] = useState('Copiar');

     const textoCriptografado = (() => {
        if (qtdEcript == 0.0) return value;

        const tamanho = value.length;
        const qtdMascarada = Math.floor(tamanho * qtdEcript);

        const mascarado = "*".repeat(qtdMascarada);
        const visivel = value.slice(qtdMascarada);

        return mascarado + visivel;
    })();

    const copiar = async (e) => {
        e.stopPropagation();

        try {
            await navigator.clipboard.writeText(value);
            setTooltip('Copiado!');
            setTimeout(() => setTooltip('Copiar'), 1500);
        } catch (err) {
            console.error('Erro ao copiar', err);
        }
    };
    return (
        <Tooltip text={tooltip}>
            <div
                className="campo-hash"
                onClick={copiar}
                type="button"
            >
                <span className="campo-hash-text">{textoCriptografado}</span>
                <MdOutlineLibraryBooks className='campo-hash-copy' />
            </div>
        </Tooltip>
    );
}
